// removed by extract-text-webpack-plugin
module.exports = {"container":"GameMovie__container___2Xe9w"};


//////////////////
// WEBPACK FOOTER
// ./src/game/GameMovie.scss
// module id = 197
// module chunks = 0